import { render, staticRenderFns } from "./PrintTagSubheader.vue?vue&type=template&id=4b43aec9&scoped=true"
import script from "./PrintTagSubheader.vue?vue&type=script&lang=js"
export * from "./PrintTagSubheader.vue?vue&type=script&lang=js"
import style0 from "./PrintTagSubheader.vue?vue&type=style&index=0&id=4b43aec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43aec9",
  null
  
)

export default component.exports